import { HttpClient, HttpRequest, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { of } from 'rxjs/internal/observable/of';
import { Injectable } from '@angular/core';
@Injectable({ providedIn: 'root' })
export class ApiService {
	constructor(private http: HttpClient) {}

	cambioPassword(jsonIn) {
		return this.http.post(environment.apiUrl + 'cms/cambioPassword/', jsonIn);
	}

	listProdotti() {
		return this.http.post(environment.apiUrl + 'prodotto/list/', {}).pipe(map((res: any) => res.result));
	}

	listAccessori() {
		return this.http.post(environment.apiUrl + 'prodotto/listAccessori/', {}).pipe(map((res: any) => res.result));
	}

	listDizionari(jsonIn) {
		return this.http.post(environment.apiUrl + 'prodotto/listDizionario/', jsonIn).pipe(map((res: any) => res.result));
	}

	getCarrello() {
		return this.http.post(environment.apiUrl + 'carrello/get?noBlock', {}).pipe(map((res: any) => res.result));
	}

	updateCarrello(jsonIn) {
		return this.http.post(environment.apiUrl + 'carrello/update', jsonIn).pipe(
			map((res: any) => {
				if (res.esito === 'KO') {
					alert(res.descrizione);
				}
				return res.result;
			}),
		);
	}

	saveOrdine(jsonIn) {
		return this.http.post(environment.apiUrl + 'ordine/save', jsonIn);
	}

	getOrdini() {
		return this.http.post(environment.apiUrl + 'ordine/get', {}).pipe(map((res: any) => res.result));
	}

	getOrdiniFiltrati(anno: number, confermato: boolean) {
		return this.http.post(environment.apiUrl + 'ordine/get', { anno, confermato }).pipe(map((res: any) => res.result));
	}

	getOrdine(id: number) {
		return this.http.post(environment.apiUrl + 'ordine/getOrdine?id=' + id, {}).pipe(map((res: any) => res.result));
	}

	confermaOrdine(jsonIn) {
		return this.http.post(environment.apiUrl + 'ordine/confirm', jsonIn);
	}

	confermaOrdineAgente(jsonIn) {
		return this.http.post(environment.apiUrl + 'ordine/confirmAgente', jsonIn).pipe(map((res: any) => res.result));
	}

	associaCliente(jsonIn) {
		return this.http.post(environment.apiUrl + 'cms/associaCliente', jsonIn).pipe(map((res: any) => res.result));
	}

	getClienti() {
		return this.http.post(environment.apiUrl + 'cms/getClienti', {}).pipe(map((res: any) => res.result));
	}

	getClientiPLM() {
		return this.http.post(environment.apiUrl + 'cms/getClientiPLM', {}).pipe(map((res: any) => res.result));
	}

	getMercati() {
		return this.http.post(environment.apiUrl + 'cms/getMercati', {}).pipe(map((res: any) => res.result));
	}

	getUtenti() {
		return this.http.post(environment.apiUrl + 'cms/getUtenti', {}).pipe(map((res: any) => res.result));
	}

	getUtente(jsonIn) {
		return this.http.post(environment.apiUrl + 'cms/getUtente', jsonIn).pipe(map((res: any) => res.result));
	}

	saveUtente(jsonIn) {
		return this.http.post(environment.apiUrl + 'cms/saveUtente', jsonIn).pipe(map((res: any) => res.result));
	}

	saveConfigurazioneUtente(jsonIn) {
		return this.http.post(environment.apiUrl + 'cms/saveConfigurazioneUtente', jsonIn).pipe(map((res: any) => res.result));
	}

	getColori() {
		return this.http.post(environment.apiUrl + 'cms/getColori', {}).pipe(map((res: any) => res.result));
	}

	associaColore(jsonIn) {
		return this.http.post(environment.apiUrl + 'cms/associaColore', jsonIn).pipe(map((res: any) => res.result));
	}

	importAs400() {
		return this.http.post(environment.apiUrl + 'import/as400?noBlock', {});
	}

	importSageX3() {
		return this.http.post(environment.apiUrl + 'import/sageX3?noBlock', {});
	}

	getTemplate() {
		return this.http.post(environment.apiUrl + 'carrello/getTemplate', {}, { responseType: 'blob' });
	}

	sendMailCarrello(jsonIn) {
		return this.http.post(environment.apiUrl + 'carrello/sendMailCarrello', jsonIn);
	}

	importTemplate(file) {
		const data: FormData = new FormData();
		data.append('file', file);
		return this.http
			.post(environment.apiUrl + 'carrello/importTemplate', data, {
				reportProgress: true,
				responseType: 'json',
			})
			.pipe(map((res: any) => res.result));
	}

	getPdfCarrello(jsonIn) {
		return this.http.post(environment.apiUrl + 'carrello/getPdfCarrello', jsonIn, { responseType: 'blob' });
	}

	changeDataConsegnaRichiesta(jsonIn) {
		return this.http.post(environment.apiUrl + 'ordine/changeDataConsegnaRichiesta', jsonIn).pipe(map((res: any) => res.result));
	}

	getPdfOrdine(jsonIn) {
		return this.http.post(environment.apiUrl + 'ordine/getPdfOrdine', jsonIn, { responseType: 'blob' });
	}

	getExcelOrdine(jsonIn) {
		return this.http.post(environment.apiUrl + 'ordine/getExcelOrdine', jsonIn, { responseType: 'blob' });
	}

	sendMailOrdine(jsonIn) {
		return this.http.post(environment.apiUrl + 'ordine/sendMailOrdine', jsonIn);
	}

	modifyOrder(jsonIn) {
		return this.http.post(environment.apiUrl + 'ordine/modifyOrder', jsonIn).pipe(map((res: any) => res.result));
	}

	getExcelTracking(jsonIn) {
		return this.http.post(environment.apiUrl + 'ordine/getExcelTracking', jsonIn, { responseType: 'blob' });
	}

	addProductToOrder(jsonIn) {
		return this.http.post(environment.apiUrl + 'ordine/addProdottoCarrelloOrder', jsonIn);
	}

	modifyOrderRow(jsonIn) {
		return this.http.post(environment.apiUrl + 'ordine/modifyOrderRow', jsonIn);
	}

	/* CONTAINER */

	saveSpedizione(jsonIn) {
		return this.http.post(environment.apiUrl + 'container/saveSpedizione', jsonIn).pipe(map((res: any) => res.result));
	}

	getSpedizioni() {
		return this.http.post(environment.apiUrl + 'container/getSpedizioni', {}).pipe(map((res: any) => res.result));
	}

	getSpedizioneCarrello() {
		return this.http.post(environment.apiUrl + 'container/getSpedizioneCarrello', {}).pipe(map((res: any) => res.result));
	}

	addContainer(jsonIn) {
		return this.http.post(environment.apiUrl + 'container/addContainer', jsonIn).pipe(map((res: any) => res.result));
	}

	deleteContainer(jsonIn) {
		return this.http.post(environment.apiUrl + 'container/deleteContainer', jsonIn);
	}

	saveProdottoContainer(jsonIn) {
		return this.http.post(environment.apiUrl + 'container/saveProdottoContainer', jsonIn).pipe(map((res: any) => res.result));
	}

	saveProdottoContainerMultiplo(jsonIn) {
		return this.http.post(environment.apiUrl + 'container/saveProdottoContainerMultiplo', jsonIn).pipe(map((res: any) => res.result));
	}

	getSpedizioneByOrder(jsonIn) {
		return this.http.post(environment.apiUrl + 'container/getSpedizioneByOrder', jsonIn).pipe(map((res: any) => res.result));
	}

	deleteSpedizione(jsonIn) {
		return this.http.post(environment.apiUrl + 'container/deleteSpedizione', jsonIn);
	}

	toggleChiudiSpedizione(jsonIn) {
		return this.http.post(environment.apiUrl + 'container/toggleChiudiSpedizione', jsonIn).pipe(map((res: any) => res.result));
	}

	getSpedizioneById(jsonIn) {
		return this.http.post(environment.apiUrl + 'container/getSpedizioneById', jsonIn).pipe(map((res: any) => res.result));
	}

	getListaTipoContainer() {
		return this.http.post(environment.apiUrl + 'container/getListaTipoContainer', {}).pipe(map((res: any) => res.result));
	}

	getProdottiContainerDaInserire(jsonIn) {
		return this.http.post(environment.apiUrl + 'container/getProdottiContainerDaInserire', jsonIn).pipe(map((res: any) => res.result));
	}

	addProdottoContainerFromDifferentSpedizione(jsonIn) {
		return this.http
			.post(environment.apiUrl + 'container/addProdottoContainerFromDifferentSpedizione', jsonIn)
			.pipe(map((res: any) => res.result));
	}

	removeProdottoContainerFromDifferentSpedizione(jsonIn) {
		return this.http
			.post(environment.apiUrl + 'container/removeProdottoContainerFromDifferentSpedizione', jsonIn)
			.pipe(map((res: any) => res.result));
	}

	setPrioritaOrdine(jsonIn) {
		return this.http.post(environment.apiUrl + 'ordine/setPrioritaOrdine', jsonIn);
	}

	searchByProductCode(codiceCommerciale: string) {
		return this.http.post(environment.apiUrl + 'prodotto/searchByProductCode/', codiceCommerciale).pipe(map((res: any) => res.result));
	}

	saveTranscodificaCliente(codiceCommerciale: string) {
		return this.http.post(environment.apiUrl + 'prodotto/saveTranscodificaCliente/', codiceCommerciale).pipe(map((res: any) => res.result));
	}

	getTranscodificheCliente() {
		return this.http.post(environment.apiUrl + 'prodotto/getTranscodificheCliente/', {}).pipe(map((res: any) => res.result));
	}

	getAgenti() {
		return this.http.post(environment.apiUrl + 'cms/getAgenti/', {}).pipe(map((res: any) => res.result));
	}

	getConfigurazioneProdottoContainer() {
		return this.http.post(environment.apiUrl + 'cms/getConfigurazioneProdottoContainer/', {}).pipe(map((res: any) => res.result));
	}

	removeConfigurazioneProdottoContainer(body: any) {
		return this.http.post(environment.apiUrl + 'cms/removeConfigurazioneProdottoContainer/', body).pipe(map((res: any) => res.result));
	}

	saveConfigurazioneProdottoContainer(jsonIn) {
		return this.http.post(environment.apiUrl + 'cms/saveConfigurazioneProdottoContainer/', jsonIn).pipe(map((res: any) => res.result));
	}

	checkProdottoVisibile(jsonIn) {
		return this.http.post(environment.apiUrl + 'prodotto/checkProdottoVisibile/', jsonIn).pipe(map((res: any) => res.result));
	}

	getGruppoConfigurazioneProdottoContainer() {
		return this.http.post(environment.apiUrl + 'cms/getGruppoConfigurazioneProdottoContainer/', {}).pipe(map((res: any) => res.result));
	}

	removeGruppoConfigurazioneProdottoContainer(body: any) {
		return this.http
			.post(environment.apiUrl + 'cms/removeGruppoConfigurazioneProdottoContainer/', body)
			.pipe(map((res: any) => res.result));
	}

	saveGruppoConfigurazioneProdottoContainer(jsonIn) {
		return this.http
			.post(environment.apiUrl + 'cms/saveGruppoConfigurazioneProdottoContainer/', jsonIn)
			.pipe(map((res: any) => res.result));
	}

	/** CONFIGURAZIONE COMPANY */

	getListaCompany() {
		return this.http.post(environment.apiUrl + 'company/findAllCompany', {}).pipe(map((res: any) => res.result));
	}

	saveCompany(body: any) {
		return this.http.post(environment.apiUrl + 'company/saveCompany', body).pipe(map((res: any) => res.result));
	}

	deleteCompany(body: any) {
		return this.http.post(environment.apiUrl + 'company/deleteCompany', body);
	}
}
